import { apiClient } from '@/api/client'

/** One navigation row as returned by the backend. */
export interface SidebarItemDTO {
  key: string
  to: string
  label: string
  icon: string
  badge: 'dot' | 'new' | null
  /** Tab inside a page (e.g. Settings) — hidden from the main sidebar. */
  is_tabbing?: boolean
}

/** A labelled group of items (Overview / Engage / ...). */
export interface SidebarSectionDTO {
  key: string
  label: string
  items: SidebarItemDTO[]
}

export const sidebarApi = {
  /**
   * GET /api/auth/sidebar/ — the dynamic, company-wise navigation tree for the
   * current user. Already filtered server-side by the company's enabled
   * features, the user's permissions, and per-company overrides.
   */
  getSidebar: (): Promise<SidebarSectionDTO[]> =>
    apiClient
      .get('/api/auth/sidebar/')
      .then((r) => (r.data?.data ?? []) as SidebarSectionDTO[]),
}
